import { create } from 'zustand';

interface TiktokState {
  selectedVideoId: string | null;
  showAgentConfig: boolean;
  setSelectedVideoId: (id: string | null) => void;
  clearSelectedVideo: () => void;
  toggleAgentConfig: () => void;
  setShowAgentConfig: (show: boolean) => void;
}

export const useTiktokStore = create<TiktokState>((set) => ({
  selectedVideoId: null,
  showAgentConfig: false,
  setSelectedVideoId: (id) => set({ selectedVideoId: id }),
  clearSelectedVideo: () => set({ selectedVideoId: null }),
  toggleAgentConfig: () => set((s) => ({ showAgentConfig: !s.showAgentConfig })),
  setShowAgentConfig: (show) => set({ showAgentConfig: show }),
}));
